(function () {
  'use strict';

  RealTimeController.$inject = [
    '$rootScope',
    '$state',
    'Asset',
    'Customer',
    'SensorService',
    'socketIOService',
    'AssetService',
    'AppUtils',
  ];

  const angular = window.angular;
  angular.module('app').component('monitoringRealTime', {
    template:'<filter-menu hide-button="true" hide-desktop="!ctrl.isMenuVisible" modal-title="general._select.an entities.asset.modelName" icon="fa-search"><div class="real-time-menu"><div class="menu-title-container"><span translate>entities.asset.assetHierarchy</span><div class="btn-group btn-group-sm pull-right"><a class="btn btn-primary btn-sm" ng-class="{disabled: !ctrl.assetId}" ui-sref=".({assetId: null})"><i class="fas fa-undo"></i></a> <a class="btn btn-primary btn-sm" ng-click="ctrl.toggleMenu()"><i ng-class="{\'fa-eye-slash\': !ctrl.isMenuVisible, \'fa-eye\': ctrl.isMenuVisible}" class="fas"></i></a></div></div><div class="menu-title-container-mobile"><a class="btn btn-primary btn-sm" ng-class="{disabled: !ctrl.assetId}" ui-sref=".({assetId: null})"><span translate>general.deselectAll</span> <i class="fas fa-undo"></i></a></div><div class="menu-content-container"><js-tree data="ctrl.assetsTree" selected="ctrl.assetId" on-select="ctrl.onSelectAsset(selected)"></js-tree></div></div></filter-menu><div class="realtime-monitoring"><div id="realtime-toggle-button"></div><div class="realtime-wrapper" ng-class="{\'show-sidebar\': ctrl.isMenuVisible, \'hide-sidebar\': !ctrl.isMenuVisible}"><div ng-hide="ctrl.assetSelected || ctrl.loading" class="realtime-message-container"><h1><span translate>general._select.an</span> <span translate>entities.asset.modelName</span></h1></div><div ng-if="ctrl.assetSelected" ng-class="{transparent: ctrl.loading}" class="realtime-body-container"><div ng-if="!ctrl.assetSelected.sensors.length" class="realtime-message-container"><h2 translate>entities.asset.messages.noSensors</h2></div><div ng-if="ctrl.assetSelected.sensors.length"><div class="marginB5"><input type="text" translate-attr="{placeholder: \'datatables.search\'}" class="form-control" ng-model="ctrl.searchTag.name"></div><div class="realtime-container"><type-value-display sensor="tag" asset-name="ctrl.assetSelected.name" asset="ctrl.assetSelected" state="tag.currentState" data="ctrl.lastValues[tag.id]" filter-by-zone="true" ng-repeat="tag in ctrl.tags | filter: ctrl.searchTag"></type-value-display></div></div></div></div></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small\'"></spinner>',
    controller: RealTimeController,
    controllerAs: 'ctrl',
    bindings: {
      $transition$: '<',
      assets: '<',
      user: '<',
    },
  });

  function RealTimeController(
    $rootScope,
    $state,
    Asset,
    Customer,
    SensorService,
    socketIOService,
    AssetService,
    utils
  ) {
    let vm = this;
    vm.isMenuVisible = true;

    vm.$onInit = function () {
      vm.lastValues = {};
      vm.assetsTree = vm.assets.tree;
      vm.assets = vm.assets.assets;

      vm.onSelectAsset = onSelectAsset;

      vm.applySearchFilter = applySearchFilter;

      vm.toggleMenu = function () {
        vm.isMenuVisible = !vm.isMenuVisible;

        window.dispatchEvent(new Event('resize'));
      };

      checkAssetParam(vm.$transition$.params().assetId);
      let columns = parseInt(vm.$transition$.params().columns);
      if (!isNaN(columns)) {
      }

      switch (columns) {
        case 1:
          vm.columns = 'col-md-12';
          break;
        case 2:
          vm.columns = 'col-md-6';
          break;
        case 3:
          vm.columns = 'col-md-4';
          break;
        default:
          vm.columns = 'col-md-3';
      }

      vm.offIOData = $rootScope.$on('io:data', onNewData);

      vm.loadData = loadData;

      vm.uiOnParamsChanged = function (params) {
        if (params.assetId !== undefined) {
          checkAssetParam(params.assetId);
        }
      };
    };

    vm.$onDestroy = function () {
      if (vm.offIOData) {
        vm.offIOData();
      }

      if (vm.assetSelected) {
        socketIOService.unsubscribe(Asset, {
          id: vm.assetSelected.id,
          customerId: vm.assetSelected.customerId,
        });
      }
    };

    function onNewData(event, data) {
      if (!data.content) {
        vm.lastValues[data.tagId] = {};
        return;
      }

      data.content.from = new Date(data.content.from);
      let current = vm.lastValues[data.tagId];
      if (current && current.from > data.content.from) {
        return;
      }
      vm.lastValues[data.tagId] = data.content;
    }

    function applySearchFilter() {
      let filter = vm.searchTag.name.toLowerCase();

      vm.tags.forEach(function (tag) {
        tag.isExcludedByFilter = tag.name.toLowerCase().indexOf(filter) === -1;
      });
    }

    function onSelectAsset(selected) {
      if (vm.assetSelected) {
        socketIOService.unsubscribe(Asset, {
          id: vm.assetSelected.id,
          customerId: vm.assetSelected.customerId,
        });
      }
      if (!selected) {
        vm.assetSelected = null;
        return;
      }

      vm.loading = true;
      vm.tags = null;
      vm.searchTag = { name: '' };
      $state.go('.', { assetId: selected });

      AssetService.findById(selected, {
        fields: ['id', 'name', 'customerId', 'currentStateId'],
        include: 'container',
      })
        .then(function (asset) {
          if (!asset) {
            vm.loading = false;
            return;
          }

          return Customer.prototype$__get__assets__sensors({
            id: asset.customerId,
            nk: asset.id,
            filter: {
              include: {
                relation: 'states',
                scope: { where: { assetStateId: asset.currentStateId } },
              },
            },
          }).$promise.then((sensors) => {
            asset.sensors = sensors;

            socketIOService.subscribe(Asset, {
              id: asset.id,
              channels: { data: true },
            });
            vm.assetSelected = asset;
            vm.loading = false;

            let tags = angular.copy(asset.sensors);
            tags.forEach(function (tag) {
              tag.currentState = tag.states ? tag.states[0] : undefined;
              loadData(tag);
            });

            vm.tags = tags;
          });
        })
        .catch(function (err) {
          console.log(err);
          vm.loading = false;
        });
    }

    function checkAssetParam(assetParam) {
      if (assetParam) {
        if (vm.assets[assetParam]) {
          vm.assetId = assetParam;
        } else {
          $state.go('.', { assetId: null, tab: null });
        }
      } else {
        vm.assetId = null;
      }
    }

    function loadData(tag) {
      onNewData(null, {
        tagId: tag.id,
        content: tag._lastData,
      });
    }
  }
})();
